import { render, staticRenderFns } from "./ViewerRank.vue?vue&type=template&id=4533f9de&"
import script from "./ViewerRank.vue?vue&type=script&lang=js&"
export * from "./ViewerRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports